
import React, { useState, useEffect } from 'react';

import TrashIcon from "../../assets/images/trash-icon.png";

// import "./batches.css";

import Amplify, { Auth } from 'aws-amplify';

const Studentmap = {}

function DeleteBatch(props) {


  const [status, setStatus] = React.useState("Delete");


  const getToken = async () => {

    Auth.currentSession().then(res => {
      ////console.log("Auth.currentSession()")
      let accessToken = res.getAccessToken()
      ////console.log("accessToken called ")
      let jwt = accessToken.getJwtToken()
      ////console.log("Got jwt ")
      ////console.log("**************")
      ////console.log(props.students)
      ////console.log("**************")

      deleteEvent(props.batch_owner, props.batch_id, jwt)

      var i = 0
      for (i = 0; i < props.students.length; i++) {
        Studentmap[props.students[i]] = "remove"
      }

      if (props.students.length > 0) {
        updateStudents(props.batch_id, Studentmap, jwt)
      }



    })
  };


  const updateStudents = async (id, Studentmap, jwt) => {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },

      body: JSON.stringify({ id: id, members: Studentmap })

    };
    ////console.log(requestOptions)
    const response = await fetch(`https://api.dev.quizwizard.net/quiz/updatestudentsbatch`, requestOptions)
    const data = await response.json();
    ////console.log(data)


  }

  useEffect(() => {
    // You need to restrict it at some point
    // This is just dummy code and should be replaced by actual
    // ////console.log("useEffect called on EventsScreen")

    document.title = 'Delete Batch';

  }, []);


  const deleteEvent = async (classowner, batch_id, jwt) => {

    ////console.log(classowner,batch_id)

    setStatus("Deleting....")
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': jwt },
      body: JSON.stringify({ classowner: classowner, batch_id: batch_id })
    }



    const response = await fetch(`https://api.dev.quizwizard.net/quiz/deletebatch`, requestOptions)
    ////console.log("Let me delete the batch for you")
    const data = await response.json();
    ////console.log(data)
    props.closedeleteevents();

  }



  function deletebatch() {





    getToken();




  }


  return (

    <div className="mypopup-box">
      <div className="mybox">
        <div className="trashIcon">
          <img src={TrashIcon} alt="" />
        </div>
        <span className="close-icon" onClick={props.closedeleteeventwindow}>&#10005;</span>
        <label>
          Are you sure you want to delete {props.batch_name}

        </label>
        <button className="popupbutton" onClick={deletebatch}>{status}</button>


      </div>

    </div>
  );



}

export default DeleteBatch;
